<template>
  <div class="testimonial">
    <img class="background-asset" src="../assets/testimonial-background.svg" alt="">
    <div class="profile-asset">
      <div class="box1">
        <div class="box2">
          <div class="testimonial-profile">
            <img class="testimonial-asset" src="https://picsum.photos/200" alt="">
          </div>
        </div>
      </div>
    </div>

    <div class="star-container">

    </div>
    <div class="main-info">
      <h6 class="name">{{ testimonialName }}</h6>
      <h6 class="company">{{ testimonialCompany }}</h6>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Testimonial',
  props: {
    testimonialName: String,
    testimonialCompany: String,

  }

}
</script>

<style lang="scss">
@import "Testimonial.scss";
</style>
